import { configFetch as fetch } from '@laigu/utils';

export const getAgentGroupsApi = () => {
  return fetch({
    url: `/agent/agent_groups`
  });
};
